import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import { CodeTypeModel } from '../core/models/code-type';
import { Table }         from '../table/types/table';
import { VehicleModel }  from './models/vehicle';
import { VehicleService} from './vehicle.service';

@Component({
  selector   : 'wor-add-vehicle-from-branch',
  template: require('./vehicle.add-from-branch.component.html')
})
export class AddVehicleFromBranchComponent implements OnInit {
  @Input() customer_id: string;

  selectedVehicle: VehicleModel;
  vehicles       : Array<VehicleModel>;

  filters = {
    customer_id: '',
    search_term: '',
    search_type: 'plate_number'
  };

  searchTypes: Array<CodeTypeModel> = [
    {
      code       : 'plate_number',
      description: this.translateService.instant('VEHICLE_SPACE.PLATE_NUMBER', { rego: 'Rego' })
    },
    {
      code       : 'vin',
      description: this.translateService.instant('VEHICLE_SPACE.VIN')
    }
  ];

  tableSettings: Table = {
    columns: [
      {
        classes: 'all-caps',
        field  : 'plate_number',
        header : {
          text: this.translateService.instant('VEHICLE_SPACE.PLATE_NUMBER', { rego: 'Rego' })
        }
      },
      {
        classes: 'text-left',
        field  : 'customer_name',
        header : {
          text: this.translateService.instant('JS_SPACE.COLUMNS.CUSTOMER_NAME')
        }
      },
      {
        classes: 'text-right',
        field  : 'vin',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('VEHICLE_SPACE.VIN')
        }
      },
      {
        classes: 'text-right',
        field  : 'make',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('VEHICLE_SPACE.MAKE')
        }
      },
      {
        classes: 'text-right',
        field  : 'model',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('VEHICLE_SPACE.MODEL')
        }
      },
      {
        classes: 'text-right',
        field  : 'build_date',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('VEHICLE_SPACE.BUILD_DATE')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_VEHICLES_FOUND')
    },
    pagination: {
      enabled  : true,
      pageSize : 5,
      pageSizes: [ 5, 10, 25, 50 ]
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService,
    @Inject(forwardRef(() => VehicleService))
    private vehicleApi      : VehicleService
  ) {}

  ngOnInit () : void {
    this.filters.customer_id = this.customer_id;

    this.getVehicles();
  }

  confirm () : Promise<void> {
    return this.vehicleApi
    .copyFromBranch(this.selectedVehicle, this.customer_id)
    .then(( response : VehicleModel ) => {
      this.activeModal.close(response);
    });
  }

  confirmVehicleSelection ( vehicle : VehicleModel ) : void {
    this.selectedVehicle = vehicle;

    this.confirm();
  }

  getVehicles ( params ?: any ) : void {
    params = params || {
      direction: 'asc',
      field    : 'plate_number',
      offset   : 0,
      pageSize : 5
    };

    this.vehicleApi
    .getBranchVehicles({
      customer_id: this.filters.customer_id,
      direction  : params.direction || 'asc',
      field      : params.field || 'plate_number',
      offset     : params.offset || 0,
      pageSize   : params.pageSize || 5,
      search_term: this.filters.search_term,
      search_type: this.filters.search_type
    })
    .then(( vehicles : Array<VehicleModel> ) => this.vehicles = vehicles);
  }

  handleVehicleSelection ( vehicle : VehicleModel ) : void {
    this.selectedVehicle = vehicle.selected
      ? vehicle
      : null;
  }
}
